export default __webpack_public_path__ + "815ed82f649be4cc8df5e9e024e23482.png";